import React from 'react';
import { Tooltip } from '@shopify/polaris';

const DEFAULT_TOOLTIP_PROPS = {
  preferredPosition: 'above',
  activatorWrapper: 'div',
  dismissOnMouseOut: true
};
function TooltipWrapper({
  disabled = false,
  children,
  content
}) {
  if (disabled) {
    return children;
  }
  return /*#__PURE__*/React.createElement(Tooltip, Object.assign({
    content: content
  }, DEFAULT_TOOLTIP_PROPS), children);
}

export { TooltipWrapper as default };
